<template>
  <div class="service-plan">
    <div class="serach-around">
      <div class="serach-around-select">
        <van-field
          class="van-cell-state"
          readonly
          clickable
          :value="selectInfo"
          :placeholder="this.$t('maintenanceState')"
          @click="showPicker = true"
        />
        <img class="cell-state-img" src="@/assets/images/icon_down@2x.png">
      </div>
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="selevtList"
          @cancel="showPicker = false"
          @confirm="onConfirm"
        />
      </van-popup>
      <div class="serach-around-select">
        <van-field
          class="van-cell-state"
          readonly
          clickable
          :value="timeInfo"
          placeholder="选择时间"
          @click="showTime = true"
        />
        <img class="cell-state-img" src="@/assets/images/icon_down@2x.png">
      </div>
      <van-popup v-model="showTime" round position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="date"
          :title="this.$t('chooseDate')"
          :min-date="minDate"
          :max-date="maxDate"
          :formatter="formatter"
          @cancel="showTime = false"
          @confirm="onConfirmTime"
        />
      </van-popup>

      <van-button plain type="info" class="serach-around-btn" @click="repairInfo">{{ $t('search') }}</van-button>
    </div>
    <div v-for="(item,index) of infolist" :key="index" class="body-around">
      <dr-maintenance :info-list="aroundlist">
        <div class="opera">
          <ul class="base-info">
            <li v-if="buttonStauts !== 2" class="info-item">
              <div class="info_label">
                <split-label class-name="label" :label="this.$t('maintenanceMan')" />
              </div>
              <div class="info_value">
                <span>{{ item.userName }}</span>
              </div>
            </li>
            <li class="info-item">
              <div class="info_label">
                <split-label class-name="label" :label="this.$t('maintenanceState')" />
              </div>
              <div class="info_value complete-btn">
                <span v-if="buttonStauts === 2" class="btn-color">{{ item.repairStatus }}</span>
                <span v-else :style=" { color : buttonStauts === 4 || buttonStauts === 3 ? '#005BAC' : '#009966' } ">{{ item.repairStatus }}</span>
              </div>
            </li>
          </ul>
          <div :style=" { top: buttonStauts === 2 ? '10px' : '25px' } " class="detail-btn-wrapper">
            <button v-if="buttonStauts === 4" class="detail-btn" @click="handleGoEvaluateClick">评价</button>
            <button v-else class="detail-btn detail-btn-detail" @click="handleGoDetailClick(infolist[index].id)">查看详细</button>
          </div>
        </div>
      </dr-maintenance>
    </div>
  </div>
</template>

<script>
import DrMaintenance from '@/components/Maintenance'
import { REPAIR_STATUS, REPAIR_STATUS_reverse } from '@/api/constants'
import { RECORD_STATUS } from '@/api/constants'

export default {
  name: 'ServiceEvaluate',
  components: { DrMaintenance },
  data() {
    return {
      selevtList: [], // 筛选下拉列表
      timeInfo: '', // 筛选时间
      // 时间范围
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(), // 筛选时间
      showPicker: false, // 弹出层
      showTime: false, // 时间选择器
      selectInfo: '', // 下拉菜单内容
      aroundlist: [], // 列表信息
      infolist: [], // 列表内容
      buttonStauts: 0 // 按钮状态
    }
  },
  mounted(res) {
    this.buttonStauts = Number(this.$route.query.key)
    this.repairInfo()
    this.selevtList = RECORD_STATUS
  },
  methods: {
    // 时间选择器
    disposeTime(s) {
      return s < 10 ? '0' + s : s
    },
    // 时间计算
    onConfirmTime(val) {
      const time = new Date(val)
      const resDate = time.getFullYear() + '-' + this.disposeTime((time.getMonth() + 1)) + '-' + this.disposeTime(time.getDate())
      this.timeInfo = resDate
      this.showTime = false
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`
      } else if (type === 'day') {
        return `${val}日`
      }
      return val
    },
    // 选择器方法
    onConfirm(value) {
      this.selectInfo = value
      this.showPicker = false
    },
    // 获取列表
    repairInfo() {
      // this.$store.commit('showLoading')
      if (this.selectInfo) {
        this.selectInfo = REPAIR_STATUS_reverse[this.selectInfo]
      }
      this.$api('REPAIR_SEARCH_H5',
        this.timeInfo ? { inputDate: this.timeInfo, repairStatus: this.selectInfo } : { repairStatus: this.selectInfo }
        , true).then((res) => {
        this.infolist = res.result.content
        for (let i = 0; i < this.infolist.length; i++) {
          this.infolist[i].repairStatus = REPAIR_STATUS[this.infolist[i].repairStatus]
          this.aroundlist = [
            { title: '出厂编号', content: this.infolist[i].deviceCode },
            { title: '产品线', content: this.infolist[i].deviceCategoryName },
            { title: '型  号', content: this.infolist[i].deviceCode },
            { title: '所属地址', content: this.infolist[i].hospitalAddress },
            { title: '报修时间', content: this.infolist[i].inputDate }
          ]
        }
        this.selectInfo = REPAIR_STATUS[this.selectInfo]
      })
    },
    handleGoDetailClick(id) {
      this.$router.push({ path: '/planParticular', query: { key: id }})
    },
    handleGoEvaluateClick() {
      this.$router.push('/checkEvaluate')
    }
  }
}
</script>

<style lang="scss" scoped>
  .info_label {
    font-weight: 700;
  }

  .info_value {
    font-weight: 700;
    .btn-color{
      color: #009966;
    }
  }

  ::v-deep .dr__maintenance .base-info {
    padding: 27px 16px;

    .info-item {
      display: flex;
    }
  }

  .service-plan {
    padding: 13.5px 15px;
    .serach-around{
      background-color: #fff;
      height: 50px;
      margin-bottom: 10px;
      padding: 5px 15px;
      display: flex;
      align-items: center;
      .serach-around-select{
        display: flex;
        align-items: center;
        width: 110px;
        margin-right: 10px;
        border: solid 0.5px #cccccc;
        border-radius: 10px ;
        padding: 0px 5px;
        .cell-state-img{
          width:10px;
          height:10px;
        }
      }
      .van-cell-state{
        font-size: 15px;
        width: 125px;
        padding: 0px;
      }
      .serach-around-select{
        height: 30px;
      }
      .serach-around-btn{
        height: 30px;
        width: 60px;
        border: none;
        font-size: 15px;
        margin-left: 15px;
      }
    }
    .body-around {
      width: 345px;
      background-color: #fff;
      margin-bottom: 13.5px;
      border-radius: 5px;
    }

    .opera {
      position: relative;

      .complete-btn {
        color: rgba(0, 91, 172, 1);
      }

      .detail-btn-wrapper {
        position: absolute;
        top: 0 !important;
        left: 250px;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:  row-reverse;
        .detail-btn {
          border: none;
          outline: none;
          padding: 9px 12px;
          background: #005BAC;
          border-radius: 15px;
          font-size: 13px;
          font-family: PingFang SC Medium, PingFang SC Medium-Medium;
          font-weight: 500;
          color: #ffffff;
          line-height: 13.5px;
        }

        .detail-btn-detail {
          border: #009966 1px solid;
          color: #009966;
          background-color: #ffffff;
        }
      }
    }
  }
</style>
